import React from 'react';

/**
 * Renders a number with appropriate formatting and colors
 * 
 * @param {number|string} value - The value to display
 * @param {boolean} isChangeValue - Whether this is a change value that needs +/- indicators
 * @param {string} className - Additional CSS classes
 */
const NumberDisplay = ({ 
    value, 
    isChangeValue = false,
    className = ''
}) => {
    // Handle null or undefined values
    if (value === null || value === undefined) {
        return <span className={`number-empty ${className}`}>—</span>;
    }
    
    // Convert to number if it's a string representation of a number
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    
    // If it's not a valid number, just display the original value
    if (isNaN(numericValue)) {
        return <span className={`number-text ${className}`}>{value}</span>;
    }
    
    // Format the number based on whether it represents a change
    const displayValue = isChangeValue && numericValue > 0 ? `+${numericValue}` : String(numericValue);
    
    // Determine color based on value
    let colorClass = 'number-neutral'; // default color
    if (isChangeValue) {
        colorClass = numericValue > 0 ? 'number-positive' : 
                     numericValue < 0 ? 'number-negative' : 
                     'number-neutral';
    }
    
    return (
        <span className={`${colorClass} ${className}`}>
            {displayValue}
        </span>
    );
};

export { NumberDisplay }; 